import React from 'react';
import "./AlertBannerLabel.scss";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIconWrapper } from "/react4xp/components/FontAwesomeIconWrapper";
import { AlertType } from '/types/alerts.d';

export function AlertBannerLabel({ className, alertType }: { className?: string, alertType: AlertType }): React.JSX.Element {
	return (
		<span className={`${getAlertLabelStyling(alertType)} text-sm leading-none ${className}`}>
			<FontAwesomeIconWrapper icon={faTriangleExclamation} size="1x" />
			{getAlertLabelText(alertType)}
		</span>
	);
}

function getAlertLabelStyling(alertType: AlertType): string{
	if (alertType === "vaer-varsom") {
		return 'alert-banner-label--careful';
	}

	return 'alert-banner-label--default';
}

function getAlertLabelText(alertType: AlertType): string{
	if (alertType === "vaer-varsom") {
		return 'Vær varsom';
	}

	return 'Varsling';
}
